import  { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Notification from '../shared/Notification';
import styles from './forget-password.module.css';
import NavHeader from './NavHeader';


const ForgetPassword = () => {
    const [error, setError] = useState('');
    const [notification, setNotification] = useState('');
    const [formData, setFormData] = useState({
        emailOrPhone: '',
    });

    const navigate = useNavigate();
    
    useEffect(() => {
        const message = localStorage.getItem('notification');
        if (message) {
            setNotification(message);
            localStorage.removeItem('notification');
        }
    }, []);

    const handleCloseNotification = () => {
        setNotification('');
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('Sending ResetPassword email...');

        try {
            
            const response = await axios.post('/api/authApplicant/forget-password', formData);
            // console.log(response.data);
            // console.log(response.data.message);
            setError(response.data.message);
            sessionStorage.setItem('verifyEmailOrPhone',formData.emailOrPhone);
            navigate('/reset-password');
            
        } catch (error) {
             if (error.response && error.response.data) {
                setNotification(error.response.data.message);
                setError(error.response.data.message);
            } else {
                setNotification('An error occurred. Please try again.');
            }
            console.error(error);
        }
    }

    return (
        <>
        <NavHeader/>
        {notification && (
            <Notification message={notification} onClose={handleCloseNotification} />
        )}
        <div className={styles.forgetPasswordContainer}>
            <form onSubmit={handleSubmit} className={styles.forgetPasswordForm}>
                <h2>Forget Password</h2>
                <input
                    type="text"
                    name="emailOrPhone"
                    placeholder="Email or Phone"
                    value={formData.emailOrPhone}
                    onChange={handleChange}
                    required
                />
                {error && (
                <div className={styles.errorMessage}>
                    <p>{error}</p>
                </div>
                )}
                <button  type="submit">Send Code</button>
                <p>Forgot EmailOrPhone? <a href="/contact-us"> Contact Us.</a></p>
                <p><a href='/login'>Back To Login.</a></p>
            </form>
        </div>
        </>
    );
};

export default ForgetPassword;